import type { ReactNode } from "react"

/**
 * Wraps a table cell's own controls, such as its tag editor, so their clicks
 * and keys never also activate the row. The controls carry the keyboard path;
 * the wrapper only stops the events.
 */
export function RowEventBoundary({
  className = "flex min-w-0 justify-end",
  children,
}: {
  className?: string
  children: ReactNode
}) {
  return (
    <div
      role="presentation"
      className={className}
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      {children}
    </div>
  )
}
